import type { BoardNode } from '../state/domain';
import { generateKeyBetween } from './core/fractional';
import type { ElementType, GfxElement, RefKind } from './core/types';

export type NodeInput = Omit<BoardNode, 'engagementId'>;

/** 画布元素 → 可持久化的 board node。 */
export function elementToNode(el: GfxElement): NodeInput {
  const { id, type, refKind, refId, z, ...rest } = el;
  return {
    id,
    type,
    refKind: refKind ?? null,
    refId: refId ?? null,
    payload: rest as unknown as Record<string, unknown>,
    z,
  };
}

/** board node → 画布元素。 */
export function nodeToElement(node: NodeInput): GfxElement {
  const payload = (node.payload ?? {}) as Record<string, unknown>;
  const props = (payload.props as Record<string, unknown>) ?? {};

  // 兼容：早期绳索锚点在卡片中心，现统吸附到顶部图钉处
  if (node.type === 'rope') {
    for (const key of ['source', 'target'] as const) {
      const endpoint = props[key] as { id?: string; anchor?: number[] } | undefined;
      if (
        endpoint &&
        Array.isArray(endpoint.anchor) &&
        Math.abs(endpoint.anchor[0] - 0.5) < 1e-6 &&
        Math.abs(endpoint.anchor[1] - 0.5) < 1e-6
      ) {
        endpoint.anchor = [0.5, 0];
      }
    }
  }

  return {
    id: node.id,
    type: node.type as ElementType,
    x: Number(payload.x ?? 0),
    y: Number(payload.y ?? 0),
    w: Number(payload.w ?? 0),
    h: Number(payload.h ?? 0),
    rotate: Number(payload.rotate ?? 0),
    z: node.z ?? generateKeyBetween(null, null),
    group: (payload.group as string | null) ?? null,
    locked: Boolean(payload.locked),
    hidden: Boolean(payload.hidden),
    local: false,
    props,
    refKind: (node.refKind as RefKind | null) ?? undefined,
    refId: node.refId ?? undefined,
  };
}

export function nodesToElements(nodes: NodeInput[]): GfxElement[] {
  return nodes.map(nodeToElement);
}